import { Box } from '@material-ui/core';
import { ArticleTypeExternal, formatDateReadable, formatMoney } from '@nemuru-eng/js-api-client';

import { DialogHeader } from '@/components/shared/components/ItemDetail/components/shared/DialogHeader';
import { ItemDetailProps } from '@/components/shared/components/ItemDetail/types/ItemDetailProps';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { Font } from '@/components/shared/components/Font';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';

export const Accommodation = ({ itemDetail, currency, itemStatus }: ItemDetailProps) => {
  if (itemDetail.article.type !== ArticleTypeExternal.ACCOMMODATION) {
    return null;
  }

  const accommodationAddress = itemDetail.article.address;

  return (
    <>
      <DialogHeader
        articleType={ArticleTypeExternal.ACCOMMODATION}
        articleDetailId={itemDetail.id}
        total={{ value: itemDetail.totalPriceWithTax, currency }}
      />
      {itemStatus && (
        <Box pb={2}>
          <StatusTag type={itemStatus.statusColor} labelTextId={itemStatus.status} />
        </Box>
      )}
      <Box paddingY={2} display={'flex'} flexDirection={'column'}>
        <Font variant={'body1'} color={'title'}>
          <Text strong tId={'SUMMARY'} />
        </Font>
        <Box pt={2}>
          <ReadOnlyDataRow labelTextId={'ACCOMMODATION'} value={itemDetail.article.name} underlined />
          {itemDetail.article.reference && (
            <ReadOnlyDataRow labelTextId={'REFERENCE'} value={itemDetail.article.reference} underlined />
          )}
          <ReadOnlyDataRow labelTextId={'UNITS'} value={`${itemDetail.units} x`} underlined />
          <ReadOnlyDataRow
            labelTextId={'UNIT_PRICE_WITH_TAX'}
            value={`${formatMoney({ value: itemDetail.article.unitPriceWithTax, currency })} `}
            underlined
          />
        </Box>
      </Box>
      <Box paddingY={2}>
        <Font variant={'body1'} color={'title'}>
          <Text strong tId={'DETAILS'} />
        </Font>
        <Box pt={2}>
          <ReadOnlyDataRow labelTextId={'DESCRIPTION'} value={itemDetail.article.description ?? '-'} underlined />
          <ReadOnlyDataRow labelTextId={'NUMBER_OF_GUESTS'} value={itemDetail.article.guests ?? '-'} underlined />
          <ReadOnlyDataRow
            labelTextId={'ADDRESS'}
            value={
              accommodationAddress
                ? `${accommodationAddress.streetAddress}${
                    accommodationAddress.streetAddress2 ? `, ${accommodationAddress.streetAddress2}` : ''
                  }, ${accommodationAddress.postalCode} - ${accommodationAddress.city}, ${accommodationAddress.country}`
                : '-'
            }
            underlined
          />
          <ReadOnlyDataRow
            labelTextId={'CHECK_IN_DATE'}
            value={itemDetail.article.checkinDate ? formatDateReadable(itemDetail.article.checkinDate) : '-'}
            underlined
          />
          <ReadOnlyDataRow
            labelTextId={'CHECK_OUT_DATE'}
            value={itemDetail.article.checkoutDate ? formatDateReadable(itemDetail.article.checkoutDate) : '-'}
            underlined
          />
        </Box>
      </Box>
    </>
  );
};
